import {Component, Inject, OnInit, inject, DestroyRef} from '@angular/core';
import {translate} from '@jsverse/transloco';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Constants } from 'src/app/models/constants';
import { FormUtilService } from 'src/app/services/util/form-util.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClipboardService } from 'ngx-clipboard';

@Component({
    selector: 'app-inventory-kubernetes',
    templateUrl: './inventory-kubernetes.component.html',
    styleUrls: ['./inventory-kubernetes.component.scss'],
    standalone: false
})
export class InventoryKubernetesComponent  implements OnInit{
  title: string = translate('DIALOG.CONFIRMATION');
  message: string;
  confirmButtonText: string = translate('DIALOG.CONFIRM');
  approveForm: FormGroup;
  Constants = Constants;
  records: any;
  selectedKind: any;
  private destroyRef = inject(DestroyRef);
  displayColumns = [
    {
      key: 'name',
      name: translate('INSTANCE_DETAILS.NAME'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: true
    },
    {
      key: 'containerName',
      name: translate('INSTANCE_DETAILS.CONTAINER_NAME'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'image',
      name: translate('INSTANCE_DETAILS.IMAGE'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: false
    },
    {
      key: 'version',
      name: translate('INSTANCE_DETAILS.VERSION'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: false
    }
  ];
  displayColumnsNoSpec = [
    {
      key: 'name',
      name: translate('INSTANCE_DETAILS.NAME'),
      type: 'text',
      sortable: true,
      visible: true,
      disable: true
    }
  ]
  selectedFilteredKind: any;
  searchTerm: string;
  searchedResult: any;
  jsonView: boolean = false;
  copy: boolean;
  formattedLines: string[] = [];
  removeSearch: boolean;


  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private formBuilder: FormBuilder, public matdialogRef: MatDialogRef<InventoryKubernetesComponent>, private clipboardApi: ClipboardService) {
    
  }

  ngOnInit(): void {
    this.title = this.data.title || this.title;
    this.message = this.data.message;
    this.records = this.data?.records;
    this.selectedKind = this.records?.kinds[0];
    this.selectedFilteredKind = this.records?.kinds[0];
    const jsonString = JSON.stringify(this.selectedFilteredKind.spec.containers, null, 2);
    this.formattedLines = jsonString.split('\n');
}

showDetails(kind: any) {
  this.removeSearch = true;
  setTimeout(() => {
    this.removeSearch = false;
  }, 10);
  this.searchTerm = '';
  this.searchedResult = '';
  this.selectedKind = kind;
  this.selectedFilteredKind = kind;
  const jsonString = JSON.stringify(this.selectedFilteredKind.spec.containers, null, 2);
  this.formattedLines = jsonString.split('\n');
}

isActive(kind: any): boolean {
  return this.selectedFilteredKind === kind;
}

search(search?: string): void {
  this.searchTerm = search;
}

searchedItems(result): void {
  this.searchedResult = result;
}

toggleView(): void {
  this.jsonView = !this.jsonView;
  if(!this.jsonView) {
    this.searchTerm = undefined;
    this.searchedResult = undefined;
  }
}

copyJson(): void {
  const jsonText = JSON.stringify(this.selectedKind, null, 2);
  navigator.clipboard.writeText(jsonText).then(() => {
  });
}

copyText(): void {
  const copyJson = JSON.stringify(this.selectedKind, null, 2);
  this.copy = true;
  this.clipboardApi.copyFromContent(copyJson);
  setTimeout(() => {
    this.copy = false;
  }, 5000);
}

}
